function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { DvrWindowDuration } from '../../../core/player/playout-data';
import { sdkLogger } from '../../../logger';
import { getLinearStreamInfo } from '../../../utils/stream-vendor';
import { TokenizedString } from '../../../utils/tokenized-string';
import { OvpUrlExtendedWindowManager } from '../ovp-url-extended-window-manager/ovp-url-extended-window-manager';
import { DvrWindowDurationValues } from '@sky-uk-ott/core-video-sdk-js-ovp-service';
export var OvpUrlTemplateManager = /*#__PURE__*/ function() {
    "use strict";
    function OvpUrlTemplateManager() {
        _class_call_check(this, OvpUrlTemplateManager);
    }
    _create_class(OvpUrlTemplateManager, null, [
        {
            key: "sortCDNsByPreferredWindowDuration",
            value: function sortCDNsByPreferredWindowDuration(modifiedCdnList) {
                var preferredWindowDuration = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : DvrWindowDuration.Restricted;
                this.logger.verbose("Sorting URLs by preferredWindowDuration - ".concat(preferredWindowDuration));
                var _obj;
                // zero means higher priority => will choose this CDN
                var sortingPriorityMap = (_obj = {}, _define_property(_obj, DvrWindowDuration.Restricted, 0), _define_property(_obj, DvrWindowDuration.Extended, 0), _define_property(_obj, DvrWindowDuration.FullEvent, 999), _obj);
                if ([
                    DvrWindowDuration.Restricted,
                    DvrWindowDuration.FullEvent
                ].includes(preferredWindowDuration)) {
                    if (preferredWindowDuration === DvrWindowDuration.FullEvent) {
                        this.logger.warn("Preferred Window Duration - ".concat(preferredWindowDuration, " - is not supported. Falling back to ").concat(DvrWindowDuration.Restricted));
                    }
                    var _obj1;
                    sortingPriorityMap = _object_spread_props(_object_spread({}, sortingPriorityMap), (_obj1 = {}, _define_property(_obj1, DvrWindowDuration.Restricted, 0), _define_property(_obj1, DvrWindowDuration.Extended, 1), _obj1));
                } else if (preferredWindowDuration === DvrWindowDuration.Extended) {
                    var _obj2;
                    sortingPriorityMap = _object_spread_props(_object_spread({}, sortingPriorityMap), (_obj2 = {}, _define_property(_obj2, DvrWindowDuration.Restricted, 1), _define_property(_obj2, DvrWindowDuration.Extended, 0), _obj2));
                }
                return modifiedCdnList.sort(function(a, b) {
                    return sortingPriorityMap[a.streamInfo.windowDuration] - sortingPriorityMap[b.streamInfo.windowDuration];
                });
            }
        },
        {
            key: "replaceUrlTemplateByStreamVariant",
            value: function replaceUrlTemplateByStreamVariant(ovpUrlTemplateParams) {
                var _this = this;
                var ovpEndpoints = ovpUrlTemplateParams.ovpEndpoints, streamVariants = ovpUrlTemplateParams.streamVariants, dvrWindowSupported = ovpUrlTemplateParams.dvrWindowSupported, playbackType = ovpUrlTemplateParams.playbackType, preferredWindowDuration = ovpUrlTemplateParams.preferredWindowDuration;
                var modifiedCdnList = [];
                this.logger.verbose("DvrWindowSupported is ".concat(dvrWindowSupported));
                ovpEndpoints.forEach(function(endpoint) {
                    var variablesInUrl = TokenizedString.findTokensBetweenDelimiters({
                        startDelimiter: '$',
                        endDelimiter: '$',
                        targetStr: endpoint.url
                    });
                    _this.logger.verbose("Variable extracted from URL between $$: ".concat(variablesInUrl.map(function(variable) {
                        return "".concat(_this.logger.verbose(variable), ", ");
                    })));
                    variablesInUrl.forEach(function(variable) {
                        var key = variable;
                        if (variable === 'mpdPeriod') {
                            return;
                        }
                        streamVariants.forEach(function(variant) {
                            if (!variant[key]) {
                                _this.logger.warn("Stream Variants do not contain URL variable");
                                return;
                            }
                            var variablesMapper = variant[key];
                            var possibleVariableValues = Object.values(variablesMapper);
                            var isVariableExpected = Boolean(_this.expectedVariablesInUrl.includes(variable));
                            for(var i = 0; i < possibleVariableValues.length; i++){
                                var possibleVariableValue = possibleVariableValues[i];
                                var value = possibleVariableValue.value;
                                if (!isVariableExpected && !possibleVariableValue.default) {
                                    // if it is not expected, then we will only use default case and skip the rest
                                    _this.logger.warn("Received an unexpected variable: ".concat(variable, ", but it is not default. Skipping"));
                                    continue;
                                }
                                var modifiedUrl = TokenizedString.replaceAll({
                                    targetStr: endpoint.url,
                                    startDelimiter: '$',
                                    endDelimiter: '$',
                                    variable: variable,
                                    value: value
                                });
                                _this.logger.verbose("Replacing URL Template variable: ".concat(variable, " by value: ").concat(value));
                                var stream = getLinearStreamInfo(modifiedUrl);
                                var windowDuration = OvpUrlExtendedWindowManager.getBestWindowDurationBasedOnPlayerCapabilitiesAndStreamProvider(playbackType, preferredWindowDuration, stream);
                                if (value === DvrWindowDurationValues.FOUR_HOUR) {
                                    continue;
                                }
                                if (!dvrWindowSupported && value === DvrWindowDurationValues.TWO_HOUR) {
                                    continue;
                                }
                                if (windowDuration === DvrWindowDuration.Restricted && value === DvrWindowDurationValues.TWO_HOUR) {
                                    continue;
                                }
                                _this.logger.verbose("Adding Modified URL: ".concat(modifiedUrl));
                                modifiedCdnList.push(_object_spread_props(_object_spread({}, endpoint), {
                                    url: modifiedUrl,
                                    streamInfo: stream
                                }));
                                if (!isVariableExpected && possibleVariableValue.default) {
                                    // if it is not expected, then we will only use default case and skip the rest
                                    _this.logger.warn("The variable ".concat(variable, " is unexpected, so using only default value (").concat(value, ") as replacement"));
                                    break;
                                }
                            }
                        });
                    });
                });
                if (preferredWindowDuration === DvrWindowDuration.FullEvent) {
                    this.logger.warn("Preferred Window Duration - ".concat(preferredWindowDuration, " - is not supported. Falling back to ").concat(DvrWindowDuration.Restricted));
                    modifiedCdnList = modifiedCdnList.filter(function(playoutCdn) {
                        return playoutCdn.streamInfo.windowDuration === DvrWindowDuration.Restricted;
                    });
                }
                if (!modifiedCdnList.length) {
                    throw new Error('OVP URL Template replacement resulted in an empty array. Probably because no variable matched streamVariants. Aborting');
                }
                return this.sortCDNsByPreferredWindowDuration(modifiedCdnList, preferredWindowDuration);
            }
        },
        {
            key: "parseUrlTemplate",
            value: function parseUrlTemplate(ovpUrlTemplateParams) {
                var _this = this;
                var modifiedCdnList = this.replaceUrlTemplateByStreamVariant(ovpUrlTemplateParams);
                this.logger.verbose("Final Modified Cdn List: ");
                modifiedCdnList.map(function(cdn) {
                    return _this.logger.verbose("".concat(cdn.url));
                });
                return modifiedCdnList;
            }
        }
    ]);
    return OvpUrlTemplateManager;
}();
_define_property(OvpUrlTemplateManager, "logger", sdkLogger.withContext('OVP_URL_TEMPLATE_MANAGER'));
_define_property(OvpUrlTemplateManager, "expectedVariablesInUrl", [
    'dvrWindowDuration'
]);

//# sourceMappingURL=ovp-url-template-manager.js.map